module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov5-357c61e0a8ca4e0c586b07b03caf4b24.jpg";